module.exports = __webpack_public_path__ + "static/img/practiceSystem_03.f7a188b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/practiceSystem_03.png
// module id = 6HX3
// module chunks = 23